import { AgentCategory } from "~/shared/enums";
import type { AgentConfig } from "~/shared/types";
import { validateGithubRepository, validateIsNotEmpty } from "~/utils/validation";

import AgentIcon from "./AgentIcon.vue";
import Icon from "./Icon.vue";

const config: AgentConfig = {
  name: "Cursor",
  category: AgentCategory.CODING,
  icon: Icon,
  agentIcon: AgentIcon,
  color: "#cccccc",
  helpUrl: "https://help.dartai.com/en/articles/12341238-ai-coding-agent-with-cursor-background-agents",
  description: "Open tasks in Cursor to reason across your whole codebase and refactor with full context",
  descriptionMarkdown: `## Overview

Integrate Dart with Cursor to streamline development workflows and enhance code quality through AI-powered assistance. This integration enables automated task creation for code reviews, bug fixes, and feature implementations while maintaining development velocity and code standards.

The integration connects Cursor's AI code editor with Dart's project management system, automatically creating tasks for code reviews, testing, and deployment based on your development workflow and project requirements. AI-generated code suggestions and completions can be tracked and managed through Dart's task system.

## Features

- AI-powered code completion and generation with context-aware suggestions
- Intelligent code refactoring and optimization recommendations
- Automated bug detection and fix suggestions with detailed explanations
- Multi-language support for Python, JavaScript, TypeScript, and more
- Code review automation with AI-generated feedback and improvement suggestions
- Integration with version control for seamless development workflow management

## Setup guide

1. Create or use existing Cursor account
2. Generate your API token from Cursor settings page
3. Navigate to Dart agents page
4. Paste your API token and GitHub repo (accepted formats: \`owner/repo\`, \`https://github.com/owner/repo\`, or \`git@github.com:owner/repo.git\`)
5. Assign development tasks to your Cursor agent in any accessible dartboard`,

  configFields: [
    {
      key: "apiKey",
      type: "password",
      label: "API Key",
      placeholder: "Your Cursor API key",
      validate: validateIsNotEmpty,
    },
    {
      type: "text",
      key: "repository",
      label: "GitHub repo",
      placeholder: "owner/repository",
      validate: validateGithubRepository,
    },
  ],
};

export default config;
